// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_kp-0";
export var fileCarousel = "_kp-2";
export var removeFileButton = "_kp-1";